import * as pdfjs from "pdfjs-dist";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// pdf.js 在浏览器端用 Web Worker 解析；视觉抽取在 Cloudflare Workers 运行时无法渲染 PDF，
// 因此把「PDF → 每页 PNG/JPEG」放在上传前的浏览器里完成。
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

const MAX_PAGES = 12; // 兜底上限：简历极少超过，控制上传体积与抽取成本
const RENDER_SCALE = 1.5; // 渲染倍率：1.5x 对 OCR 已足够，更小更快、上传与抽取更省
const JPEG_QUALITY = 0.85;

/** 把 PDF 文件逐页渲染为 JPEG Blob（按页序）。 */
export async function renderPdfToImages(file: File): Promise<Blob[]> {
  const data = new Uint8Array(await file.arrayBuffer());
  const pdf = await pdfjs.getDocument({ data }).promise;
  try {
    const pageCount = Math.min(pdf.numPages, MAX_PAGES);
    const blobs: Blob[] = [];
    for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const viewport = page.getViewport({ scale: RENDER_SCALE });
      const canvas = document.createElement("canvas");
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const context = canvas.getContext("2d");
      if (!context) throw new Error("无法创建画布上下文");
      await page.render({ canvasContext: context, viewport }).promise;
      const blob = await new Promise<Blob | null>((resolve) =>
        canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY),
      );
      if (blob) blobs.push(blob);
      // 释放画布内存
      canvas.width = 0;
      canvas.height = 0;
    }
    return blobs;
  } finally {
    await pdf.destroy();
  }
}
